<template>
  <div class="map" id="map">
    <img v-if="img" :src="img" />
    <img v-else :src="defaultImg" />
  </div>
</template>

<script>
export default {
  props: {
    no: {
      type: Number,
      default: null,
    },
  },

  watch: {
    no (val) {
      this.renderImg(val);
    },
  },

  data () {
    return {
      img: null,
      defaultImg: null,
    };
  },

  created () {
    this.renderImg(this.no);
  },

  methods: {
    async renderImg () {
      try {
        this.defaultImg = require(`./../../../assets/images/${this.no}.jpg`);
        const list = await this.getCgqList(this.no);
        let blue = 0;
        let green = 0;
        let red = 0;

        let index = 0;
        let min = Number(list[0].value)

        list.map((o, i) => {
          // 找值最小值的 index
          console.log(min, Number(o.value));
          if (Number(o.value) < min) {
            index = i
            min = Number(o.value)
          }
          if (Number(o.value) > o.uperLimit) {
            red++;
          } else if (Number(o.value) < o.lowerLimit) {
            blue++;
          } else {
            green++;
          }
        });

        console.log('red green blue:', red, green, blue);


        if (red > 0 && green > 0 && blue > 0) {
          this.img = require(`./../../../assets/images/${this.no}_green.jpg`);
        } else {
          if (Number(list[index].value) > list[index].uperLimit) {
            this.img = require(`./../../../assets/images/${this.no}_red.jpg`);
          } else if (Number(list[index].value) < list[index].lowerLimit) {
            this.img = require(`./../../../assets/images/${this.no}_blue.jpg`);
          } else {
            this.img = require(`./../../../assets/images/${this.no}_green.jpg`);
          }
        }







        // if (red > 0) {
        //   this.img = require(`./../../../assets/images/${this.no}_red.jpg`);
        // } else if (green >= 1 && blue < 2) {
        //   this.img = require(`./../../../assets/images/${this.no}_green.jpg`);
        // } else {
        //   this.img = require(`./../../../assets/images/${this.no}_blue.jpg`);
        // }
      } catch (e) {
        console.error("e:", e);
      }
    },

    async getCgqList (no) {
      await this.$toast.loading({
        message: this.$t("common.loading"),
        forbidClick: true,
        duration: 0,
      });

      return await this.$api
        .getLiveList({
          no,
          limit: 1,
          startDate: "2020-01-01 00:00:00",
          endDate: this.$setime(new Date(), 1),
        })
        .then((res) => {
          if (res.errcode === 0) {
            if (!this.$isblank(res.list)) {
              const list = res.list;
              const relist = [...list[0].data]
                .map((item, index) => {
                  return {
                    isWater: item.oriName === "土壤张力",
                    sort: item.oriName === "土壤张力" ? 888 + index : index,
                    ...item,
                    showPopover: false,
                  };
                })
                .sort((a, b) => a.sort - b.sort);

              const _list = relist
                .map((o) => {
                  if (o.isWater) return o;
                })
                .filter((o) => o)
                .sort((a, b) => a.channelNo - b.channelNo);

              return _list;
            } else {
              return [];
            }
          } else {
            // 其他异常
            this.$toast(res.errmsg);
            return [];
          }
        })
        .catch((err) => {
          this.$toast(this.$t("common.timeout"));
          return [];
        })
        .finally(() => {
          this.$toast.clear();
        });
    },
  },
};
</script>

<style scoped lang="scss">
.map {
  width: calc(100%);
  // height: 255px;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
